import FormProduct from "../components/FormProduct";
import { ACTION } from "../conts";

const ProductGroupEdit = () => {
  return <FormProduct action={ACTION.EDIT} />;
};

export default ProductGroupEdit;
